import React from 'react';

const AlbumTile = ({ album, onClick }) => {
  // Use a placeholder if no artwork is available
  const artworkUrl = album.artworkUrl || "https://via.placeholder.com/300?text=No+Artwork";

  return (
    <div
      onClick={onClick}
      className="aspect-square rounded-lg overflow-hidden shadow-lg relative cursor-pointer group"
    >
      <img 
        src={artworkUrl} 
        alt={album.name}
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/30 group-hover:bg-black/50 transition-all duration-300"></div>
      <p className="absolute bottom-2 left-2 right-2 text-white text-lg font-bold drop-shadow-md truncate">
        {album.name}
      </p>
    </div>
  );
};

export default AlbumTile;